// src/components/View_card.jsx
import React from 'react';
import { FaSync } from 'react-icons/fa';
import { alert_error, alert_success } from '../../AppContext.js';
import { Cookies } from '../../index.js';
import { useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import Language_i18 from '../../js/useNationalLanguage.jsx';
import axios from 'axios';
import CountryFlagsUI from '../../app_structure/app_fontend/country_flags_ui.jsx';

// Nhãn hai ngôn ngữ lưu trực tiếp vào file
const translations = {
  vi: {
    not_logged_in_line1: 'Bạn chưa đăng nhập',
    not_logged_in_line2: '',
    copied: 'Đã sao chép',
    balance: 'Số Dư',
    balance_tooltip: 'Số Hust coin hiện tại',
    level: 'Cấp độ',
    totalEarned: 'Tổng Coins đã kiếm',
    total_tooltip: 'Dùng để thăng cấp tài khoản',
    limit: 'Hạn mức',
    limit_tooltip: 'Dùng để bán Coins, tăng khi kiếm Coins',
    status: 'Trạng thái',
    status_tooltip: 'Không ảnh hưởng tính năng khác',
    telegram: 'Telegram liên kết',
    email: 'Email liên kết',
    admin: 'Admin liên kết',
    not_set: 'Chưa có',
    notification: 'Thông báo',
    tele_connect: 'Kết nối Tele',
    on: 'Bật',
    off: 'Tắt',
    region: 'Khu vực',
    change_national: 'Waiting ...'
  },
  en: {
    not_logged_in_line1: 'You are not logged in',
    not_logged_in_line2: '',
    copied: 'Copied to clipboard',
    balance: 'Balance',
    balance_tooltip: 'Current coin balance',
    level: 'Level',
    totalEarned: 'Total Coins Earned',
    total_tooltip: 'Used to upgrade account',
    limit: 'Limit',
    limit_tooltip: 'Used for selling coins/upgrading',
    status: 'Status',
    status_tooltip: 'Does not affect other features',
    telegram: 'Linked Telegram',
    email: 'Linked Email',
    admin: 'Linked Admin',
    not_set: 'Not set',
    notification: 'Notification',
    tele_connect: 'Connect Tele',
    on: 'On',
    off: 'Off',
    region: 'Region',
    change_national: 'Waiting ...'
  }
};

export default function View_card({
  username,
  openpicker,
  switch_router,
  money,
  namelevel,
  total_nap,
  limit,
  profile,
  openGooglelogin
}) {
  // Lấy ngôn ngữ từ i18n hook
  const { lang } = Language_i18();
  const t = translations[lang] || translations.vi;

  const national_market = useSelector(state => state.national_market);
  const apikey = Cookies.get('apikey');

  const truncate = (str, len = 12) =>
    str && str.length > len ? str.slice(0, len) + '…' : str;

  const saochep = (value) => {
    alert_success(t.copied);
    window.saochepnative(value);
  };

  const change_national = async () => {
    alert_success(t.change_national);
    Cookies.remove('national_market');
    try {
      const key = Cookies.get('apikey');
      const url = `https://hust.media/api/profile/national_market.php?apikey=${key}&service_national=change&national_market=delete`;
      const resp = await axios.get(url);
      if (resp.data.status == '1') {
        setTimeout(() => { window.location.href = '/reactapp/convert_national_market'; }, 150);
      } else {
        resp.data.message && alert_error(resp.data.message);
      }
    } catch (err) {
      alert_error('Error changing national market:', err);
    }
  };

  return (
    <div className="ml-1 mr-1 mb-1">
      <div className="mt-1 ml-1 mr-1 py-2 bg-green-300 shadow-lg rounded-3xl">
        {!apikey ? (
          <div className="mx-2 flex rounded-3xl bg-gray-100 dark:bg-pink-200 flex-col items-center py-4">
            <button onClick={() => saochep(username)} className="text-xl">
              {t.not_logged_in_line1}<br />
              {t.not_logged_in_line2}
            </button>
          </div>
        ) : !username ? (
          <div className="mt-4 flex justify-center items-center">
            <ClipLoader size={90} />
          </div>
        ) : (
          <>
            <div className="mx-2 mb-1 flex rounded-3xl bg-gray-100 dark:bg-pink-200 flex-col items-center py-4">
              <button onClick={() => saochep(username)} className="text-xl">
                {username}
              </button>
            </div>

            <div className="grid grid-cols-5 px-1 items-center justify-around divide-x">
              {/* Balance */}
              <div onClick={() => alert_success(t.balance_tooltip)} className="flex-1 px-1 flex flex-col items-center">
                <div className="text-base font-bold break-all dark:text-gray-500">{money}</div>
                <div className="text-base font-medium">{t.balance}</div>
              </div>
              {/* Level */}
              <div onClick={() => switch_router('/shop/plan?app=showadview')} className="flex-1 px-1 flex flex-col items-center">
                <div className="text-base font-bold break-all dark:text-gray-500">{namelevel}</div>
                <div className="text-base font-medium">{t.level}</div>
              </div>
              {/* Total Earned */}
              <div onClick={() => alert_success(t.total_tooltip)} className="flex-1 px-1 flex flex-col items-center">
                <div className="text-base font-bold break-all dark:text-gray-500">{total_nap}</div>
                <div className="text-base font-medium">{t.totalEarned}</div>
              </div>
              {/* Limit */}
              <div onClick={() => alert_success(t.limit_tooltip)} className="flex-1 px-1 flex flex-col items-center">
                <div className="text-base font-bold break-all dark:text-gray-500">{limit}</div>
                <div className="text-base font-medium">{t.limit}</div>
              </div>
              {/* Status */}
              <div onClick={() => alert_success(t.status_tooltip)} className="flex-1 px-1 flex flex-col items-center">
                <div className="text-base font-bold dark:text-gray-500">{profile.status_detail}</div>
                <div className="text-base font-medium">{t.status}</div>
              </div>
            </div>
          </>
        )}

        {profile && apikey && (
          <div className="grid grid-cols-5 px-1 items-center justify-around divide-x text-sm text-center">
            {/* Telegram */}
            <div className="flex-1 px-1 flex flex-col items-center">
              <span className="text-base font-bold break-all dark:text-gray-500">
                {truncate(profile.phone)}
              </span>
              <div className="flex items-center">
                <div className="text-base font-medium">{t.telegram}</div>
                <FaSync className="text-xs cursor-pointer" onClick={() => switch_router('/reactapp/themsdt?app=showadview')} />
              </div>
            </div>

            {/* Email */}
            <div className="flex-1 px-1 flex flex-col items-center">
              <div className="text-base font-bold break-all dark:text-gray-500">
                {truncate(profile.email)}
              </div>
              <div className="flex items-center">
                <div className="text-base font-medium">{t.email}</div>
                <FaSync className="text-xs cursor-pointer" onClick={openGooglelogin} />
              </div>
            </div>

            {/* Admin */}
            <div className="flex-1 px-1 flex flex-col items-center">
              <div className="flex items-center">
                <span className="text-base font-bold break-all dark:text-gray-500">
                  {truncate(profile.username_ref || t.not_set)}
                </span>
                <FaSync className="ml-1 text-xs cursor-pointer" onClick={() => openpicker('change_ref')} />
              </div>
              <div className="text-base font-medium">{t.admin}</div>
            </div>

            {/* Notification */}
            <div className="flex-1 px-1 flex flex-col items-center">
              <div className="flex items-center">
                <span className="text-base font-bold break-all dark:text-gray-500">
                  {profile.noti == 2 ? t.tele_connect : profile.noti == 1 ? t.on : t.off}
                </span>
                <FaSync className="ml-1 text-xs cursor-pointer" onClick={() => openpicker('change_noti')} />
              </div>
              <div className="text-base font-medium">{t.notification}</div>
            </div>

            {/* Region */}
            <div className="flex-1 px-1 flex flex-col items-center">
              <div className="flex items-center">
                <div className="text-base font-bold break-all dark:text-gray-500">
                  {truncate(national_market || t.not_set)}
                </div>
                <FaSync className="ml-1 text-xs cursor-pointer" onClick={change_national} />
              </div>
              <div className="text-base font-medium flex gap-1">{t.region} <CountryFlagsUI marketCode={national_market} fallbackCode="en" /></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
